/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import ParticlesAuth from "pages/AuthenticationInner/ParticlesAuth";
import React, { useEffect, useState } from "react";
import { Form, Link, useLocation, useNavigate } from "react-router-dom";
import { Card, CardBody, Col, Container, Row } from "reactstrap";

//import images
//import logoLight from "../../assets/images/logo-light.png";
// import logoLight from "../../assets/images/landscapeV1.svg";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import {
  confirmRegisteredUser,
  resendAuthenticationEmail,
} from "slices/thunks";
import "./Authentication.scss";
import logoAiCare from "../../assets/images/pn.png";
import logoAiCareEsteso from "../../assets/images/aicare.png";
import loghiNazionali from "../../assets/images/loghi-nazionali.png";

const RegisterConfirm = (props: any) => {
  const location = useLocation();
  const [userToken, setUserToken] = useState("");
  const [user, setUser] = useState<any>({});
  const dispatch: any = useDispatch();
  const history = useNavigate();
  const [loader, setLoader] = useState(true);
  const [resendedEmail, setResendedEmail] = useState(false);

  const validation = useFormik({
    initialValues: {},
    onSubmit: async (values) => {
      setLoader(true);

      const data = await dispatch(
        confirmRegisteredUser({ userToken }, history)
      );
      setUser(data);

      setLoader(false);
    },
  });

  const resendValidationMail = useFormik({
    initialValues: {},
    onSubmit: async (values) => {
      setLoader(true);

      const data = await dispatch(
        resendAuthenticationEmail({ userToken }, history)
      );
      setUser(data);
      setResendedEmail(true);
      setLoader(false);
    },
  });

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    if (token) {
      setUserToken(token);
      validation.handleSubmit();
    }
  }, [location.search]);

  document.title = "Confirm Account";

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <div
          className="mb-lg-5"
          style={{ textAlign: "center", backgroundColor: "#fff" }}
        >
          <span className="logo-lg">
            <img
              src={loghiNazionali}
              alt=""
              className="img-fluid"
              style={{ minHeight: 30, maxHeight: 80 }}
            />
          </span>
        </div>
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={logoAiCare} alt="" height="45" />
                      <img src={logoAiCareEsteso} alt="" height="45" />
                    </Link>
                  </div>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4">
                  {loader ? (
                    <div>
                      <CardBody className="p-4">
                        <div className="loading-container p-2 mt-4">
                          <h5 className="text-primary text-center loading-text">
                            Loading...
                          </h5>
                        </div>
                      </CardBody>
                    </div>
                  ) : resendedEmail ? (
                    <CardBody className="p-4">
                      <div className="text-center mt-2">
                        <h3 className="text-success">
                          Una nuova email di conferma è stata inviata!
                        </h3>
                      </div>
                      <div className="p-2 mt-4">
                        <h5 className="text-success text-center">
                          Controlla la tua email per completare la procedura.
                        </h5>
                        <p className="text-center mt-3">
                          Se l'email non è arrivata, clicca qui per rinviarla:
                        </p>
                        <div className="text-center mt-3">
                          <button
                            className="btn btn-primary"
                            onClick={(e) => {
                              e.stopPropagation();
                              resendValidationMail.handleSubmit();
                            }}
                          >
                            Reinvia Email
                          </button>
                        </div>
                      </div>
                    </CardBody>
                  ) : user?.email ? (
                    <CardBody className="p-4">
                      <div className="text-center mt-2">
                        <h3 className="text-primary">
                          Grazie per aver confermato il tuo account!
                        </h3>
                      </div>
                      <div className="p-2 mt-4">
                        <h5 className="text-primary text-center">
                          Sei arrivato nella pagina per completare la registrazione!
                        </h5>
                      </div>
                      <div className="p-2 mt-4">
                        <h5 className="text-primary text-center">
                          Stai per essere reindirizzato alla pagina di accesso!
                        </h5>
                      </div>
                    </CardBody>
                  ) : (
                    <CardBody className="p-4">
                      <div className="text-center mt-2">
                        <h3 className="text-danger">
                          Errore durante la conferma dell'account!
                        </h3>
                      </div>
                      <div className="p-2 mt-4">
                        <h5 className="text-danger text-center">
                          Si è verificato un problema durante la convalida dell'utente.
                        </h5>
                        <p className="text-center mt-3">
                          Se desideri riprovare la convalida, fai clic qui sotto:
                        </p>
                        <div className="text-center mt-3">
                          <button
                            className="btn btn-primary"
                            onClick={(e) => {
                              e.stopPropagation();
                              resendValidationMail.handleSubmit();
                            }}
                          >
                            Riprova Convalida
                          </button>
                        </div>
                      </div>
                    </CardBody>
                  )}
                </Card>
                <div className="mt-4 text-center">
                  <p className="mb-0">
                    Possiedi già un account?{" "}
                    <Link
                      to="/login"
                      className="fw-semibold text-primary text-decoration-underline"
                    >
                      {" "}
                      Accedi{" "}
                    </Link>{" "}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default RegisterConfirm;
